import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";


export interface Props {
    columns: string[];
    rows: string[];
    /**Celdas, el primer indice es la fila y el segundo la columna */
    cells: (JSX.Element | null)[][];
}



/**Dibuja una matriz  */
export class Matrix extends React.PureComponent<Props> {
    render() {
        const rowDimensionStyle: React.CSSProperties = {
            background: "D0F3FF",
            fontWeight: "bold",
            textAlign: "center"
        };

        const props = this.props;
        const header =
            <tr>
                <th />
                {props.columns.map((x, i) => <th style={rowDimensionStyle} key={i}>{x}</th>)}
            </tr>;

        const items =
            props.rows.map((row, rowIndex) =>
                <tr key={rowIndex} >
                    <td style={rowDimensionStyle} >{row}</td>
                    {props.columns.map((col, colIndex) =>
                        <td key={colIndex} >
                            {this.props.cells[rowIndex][colIndex]}
                        </td>
                    )}
                </tr>
            );

        return (
            <kea.Table header={header} items={items} />
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/matricestarifa/edit/componentes/matrix/index.tsx